import React from "react";
import { PageHeader } from "@/components/ui-blocks/PageHeader";
import { CSRSection } from "@/components/sections/CSRSection";
import { TransparencyStrip } from "@/components/sections/TransparencyStrip";

export default function CSRPage() {
  return (
    <main>
      <PageHeader eyebrow="CSR" title="CSR partnerships that deliver." lead="CSR-1 registered. Section 135 aligned. Audited utilization certificates for every rupee." />
      <CSRSection />
      <TransparencyStrip />
    </main>
  );
}
